import { z } from 'zod';
import { nonEmptyString } from './common.js';
/**
 * Environments are the project's own list of places a run happens — Dev,
 * Staging, a release stand. A run, a test case and a checklist point at one of
 * them, so the name is written once and never drifts into near-duplicates
 * ("staging", "Staging ", "stage") the way free text did.
 */
/** What a new project starts with; ordinary rows that can be renamed or removed. */
export const DEFAULT_ENVIRONMENTS = ['Dev', 'Staging', 'Production'];
export const environmentNameSchema = nonEmptyString(60, 'Name');
export const createEnvironmentSchema = z.object({
    name: environmentNameSchema,
});
export const updateEnvironmentSchema = z
    .object({
    name: environmentNameSchema.optional(),
})
    .refine((value) => Object.keys(value).length > 0, { message: 'Nothing to update' });
//# sourceMappingURL=environment.js.map